import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";

const IconHolidays = ({ size, ...props }) => (
	<div className="icon-holidays">
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...(size !== undefined && { width: size, height: size })}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M15 4.99983C15.8683 4.13161 17.684 2.39192 18.5 1.93536C19.5637 1.3403 20.6279 1.2262 21.8101 1.93536C21.9157 1.99869 22.004 2.08703 22.0674 2.19258C22.7865 3.3909 22.6687 4.45404 22.0674 5.51451C21.608 6.3248 19.8663 8.13352 19 8.99979L17.5 10.4999L20.2887 17.6359C20.5387 18.5857 20.2653 19.5968 19.5708 20.2912L18.7542 21.1075C18.594 21.2676 18.3701 21.3468 18.1449 21.3229C17.9197 21.2991 17.7173 21.1747 17.5943 20.9846L13 14.5L10 17.5L10.5686 20.4943C10.5937 20.7207 10.5146 20.9464 10.3534 21.1075L8.93104 22.5296C8.76057 22.7 8.51857 22.7781 8.28062 22.7395C8.04268 22.7009 7.8378 22.5503 7.72997 22.3347L5.7082 18.292L1.66465 16.2706C1.44899 16.1628 1.29831 15.9579 1.25969 15.7199C1.22107 15.4819 1.29923 15.2398 1.46973 15.0694L2.89211 13.6473C3.05321 13.4862 3.27878 13.4071 3.5052 13.4323L6.5 14L9.5 11.0001L3.01501 6.40809C2.82482 6.28505 2.70043 6.08264 2.67656 5.85738C2.6527 5.63212 2.73192 5.40814 2.89211 5.24799L3.70872 4.43165C4.40325 3.73726 5.41436 3.46399 6.36415 3.71389L13.5 6.50003L15 4.99983Z"
				fill="currentColor"
			/>
		</svg>
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...(size !== undefined && { width: size, height: size })}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M8.95006 11V21H10.2501V11C10.2501 9.48122 11.4813 8.25 13.0001 8.25H19.0001C20.5189 8.25 21.7501 9.48122 21.7501 11V21H22.0003C22.5526 21 23.0003 21.4477 23.0003 22C23.0003 22.5523 22.5526 23 22.0003 23H2.00024C1.44796 23 1.00024 22.5523 1.00024 22C1.00024 21.4477 1.44796 21 2.00024 21H2.25006V14.75H5.26718C5.68139 14.75 6.01718 14.4142 6.01718 14C6.01718 13.5858 5.68139 13.25 5.26718 13.25H2.25006V10.75H5.26718C5.68139 10.75 6.01718 10.4142 6.01718 10C6.01718 9.58579 5.68139 9.25 5.26718 9.25H2.25006V6.75H5.26718C5.68139 6.75 6.01718 6.41421 6.01718 6C6.01718 5.58579 5.68139 5.25 5.26718 5.25H2.25006V4C2.25006 2.48122 3.48128 1.25 5.00006 1.25H13.0001C14.5189 1.25 15.7501 2.48122 15.7501 4V6.95H13.0001C10.7633 6.95 8.95006 8.76325 8.95006 11ZM16.7501 19V21H15.2501V19C15.2501 18.5858 15.5859 18.25 16.0001 18.25C16.4143 18.25 16.7501 18.5858 16.7501 19ZM15.0001 12.25C14.5859 12.25 14.2501 12.5858 14.2501 13C14.2501 13.4142 14.5859 13.75 15.0001 13.75H17.0001C17.4143 13.75 17.7501 13.4142 17.7501 13C17.7501 12.5858 17.4143 12.25 17.0001 12.25H15.0001ZM15.0001 15.25C14.5859 15.25 14.2501 15.5858 14.2501 16C14.2501 16.4142 14.5859 16.75 15.0001 16.75H17.0001C17.4143 16.75 17.7501 16.4142 17.7501 16C17.7501 15.5858 17.4143 15.25 17.0001 15.25H15.0001Z"
				fill="currentColor"
			/>
		</svg>
	</div>
);

IconHolidays.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default IconHolidays;
